<h3 mat-dialog-title *ngIf="data.title">{{data.title}}</h3>
<mat-dialog-content style="text-align: center;">
    <mat-icon *ngIf="data.icon" [ngClass]="data.icon_class">{{data.icon}}</mat-icon>
    <h2 style="font-weight: 800;" *ngIf="data.message">{{ data.message }}</h2>
    <h4 *ngIf="data.message2" [innerHTML]="data.message2"></h4>
</mat-dialog-content>
<mat-dialog-actions style="justify-content: center;">
  <button *ngFor="let button of data.buttons" mat-raised-button [ngClass]="button.class" (click)="onButtonClick(button.value)">
    {{ button.name }}
  </button>
</mat-dialog-actions>
